import ApplicationStyles from 'app/styles/ApplicationStyles';
import { Colors } from 'app/styles';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    appBarSpacer: theme.mixins.toolbar,
    container: {
        flex: 1,
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'row'
    },
    content: {
        flexGrow: 1,
        paddingBottom: 8,
        height: '100vh',
        overflow: 'auto',
    },
    button: {
        marginLeft: 8,
    },
    divCharts: {
        display: 'flex',
        justifyContent: 'center'
    },
    root: {
        display: 'flex',
        flexGrow: 1,
    },
    rootPaper: {
        padding: '16px',
        margin: '16px'
    },
    rootCharts: {
        margin: '16px'
    },
    textPercentage: {
        display: 'flex',
        justifyContent: 'center'
    },
    headerDrawer: {
        display: 'flex',
        alignItems: 'center'
    },
    deleteIcon: {
        color: Colors.red,
        fontSize: 20,
    },
    editIcon: {
        color: Colors.primary,
        fontSize: 20,
    },
    buttons: {
        display: 'flex',
        flexDirection: 'row',
    },
    
}));

export const styles = ({
    ...ApplicationStyles.margins,
    ...ApplicationStyles.flexBox,
    titleBox: {
        ...ApplicationStyles.margins.baseHorizontalMargin,
        ...ApplicationStyles.margins.smallVerticalMargin
    },
    inputSelect:{
    	width: '100%',
    	paddingRight: 8,
        paddingBottom: 10,
    },
    drawerStyle: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e8e8e8',
        padding: '10px 16px',
        textAlign: 'right',
        left: 0,
        background: '#fff',
        borderRadius: '0 0 4px 4px',
    },
    dividerDefault:{
        margin:0,
        paddingBottom: '16px',
        fontSize: '12px',
        color: 'gray',
    }
})
